import React from "react";
import { asArray, getElemenSlug } from "../utils/tools";
import { useMyContext } from "../components/myContext";
import get from "lodash/get";
import { Settings } from "../utils/settings";
import { Debug } from "../components/debug";

function checkSource(source, Field) {
  if (!source) {
    console.warn(
      `existentFields: Missing source prop for '${getElemenSlug(
        Field
      )}', this field will be discarded`
    );
  }
}

export function onlyExistentFields(
  fields,
  resource,
  action,
  forcedCustomFields,
  removedCustomFields,
  type = "response_fields"
) {
  const { acp } = useMyContext();
  const isSuperuser = acp.isSuperuser();

  forcedCustomFields = forcedCustomFields || [];
  removedCustomFields = removedCustomFields || [];

  const existentFields = acp.allowedFields(resource, action, type) || [];
  const allowedFields = [...existentFields, ...forcedCustomFields].filter(
    (x) => !removedCustomFields.includes(x)
  );

  const res = asArray(fields)
    .map((Field, idx) => {
      if (!Field) return null;

      const source = get(Field, "props.source", "");
      checkSource(source, Field);

      let showField = false;

      const canPropIsSet =
        Field.props != null &&
        Object.prototype.hasOwnProperty.call(Field.props, "can");
      const isAllowedSource = allowedFields.includes(source);

      if (canPropIsSet) {
        showField = acp.can(Field.props.can);
      } else {
        showField = isSuperuser || isAllowedSource;
      }

      if (showField) {
        return React.cloneElement(Field, { key: idx });
      }

      if (
        Settings.debugging() &&
        Settings.getDebugSetting("show_restricted_elements")
      ) {
        return (
          <Debug
            key={idx}
            {...Field.props}
            label={`[NotFound ${source}] ${Field.props.label || source}`}
          >
            {Field}
          </Debug>
        );
      }

      return null;
    })
    .filter((v) => v);

  return res;
}
